import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AutomationRunsListOpenedLocation, withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationRunsListOpened.meta';

export type UseTrackAutomationRunsListOpenedParams = {
  automation_id: string;
  location: AutomationRunsListOpenedLocation;
};

export const useTrackAutomationRunsListOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationRunsListOpened = useCallback(
    (params: UseTrackAutomationRunsListOpenedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationRunsListOpened };
};
